import React from 'react';
import { Skeleton } from '@mui/lab';

const DataLabel = (props) => {
  const {
    title, value, loading
  } = props;

  return (
    <div style={styles.container}>
      <div style={styles.title}>{title}</div>
      {loading ?
        <Skeleton height={24} />
        : <div style={styles.value}>{value ? value : '-'}</div>
      }
    </div>
  )
}

const styles = {
  container: {
    padding: '0.5rem 0.5rem'
  },
  title: {
    fontSize: '.75rem',
    color: 'grey'
  },
  value: {
    fontSize: '1rem'
  }
}

export default DataLabel;

